import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { FieldInputProps, FieldMetaProps } from 'formik';

import CustomTextField from '~/components/fields/CustomTextField/CustomTextField';
import { formatCardNumber, formatExpiryDate } from '~/utils/handle-input-events';
import { creditCardDetails } from '~/utils/credit-card-details';

export interface PaymentMethodFormProps {
  getFieldProps: (name: string) => FieldInputProps<any>;
  getFieldMeta: (name: string) => FieldMetaProps<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  cardNumber: string;
}

const PaymentMethodForm: React.FC<PaymentMethodFormProps> = ({
  getFieldMeta,
  getFieldProps,
  handleChange,
  cardNumber,
}) => {
  const { maxLength: cardNumberMaxLength, cvvLength } = creditCardDetails(cardNumber);
  const { t } = useTranslation();
  return (
    <div>
      <CustomTextField
        name="cardHolder"
        type="text"
        label={t('checkoutPage:nameOnCard')}
        placeholder="Name"
        meta={getFieldMeta('cardHolder')}
        field={getFieldProps('cardHolder')}
        onChange={handleChange}
      />
      <CustomTextField
        name="cardNumber"
        type="text"
        label={t('checkoutPage:cardNumber')}
        placeholder="XXXX XXXX XXXX XXXX"
        meta={getFieldMeta('cardNumber')}
        field={getFieldProps('cardNumber')}
        onChange={handleChange}
        onInput={formatCardNumber}
        maxLength={cardNumberMaxLength}
        inputMode="numeric"
      />
      <Row gutter={[30, 30]}>
        <Col span={24} md={12}>
          <CustomTextField
            name="expirationDate"
            type="text"
            label={t('checkoutPage:expirationDate')}
            placeholder="MM/YY"
            meta={getFieldMeta('expirationDate')}
            field={getFieldProps('expirationDate')}
            onChange={handleChange}
            onInput={formatExpiryDate}
            inputMode="numeric"
          />
        </Col>
        <Col span={24} md={12}>
          <CustomTextField
            name="cvv"
            type="text"
            label={t('checkoutPage:cvv')}
            placeholder="123"
            meta={getFieldMeta('cvv')}
            field={getFieldProps('cvv')}
            onChange={handleChange}
            inputMode="numeric"
            maxLength={cvvLength}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentMethodForm;
